<template>
	<div id="app">
		<router-view></router-view>
		<tail></tail>
	</div>
</template>

<script>
	import tail from './components/tail.vue'
	export default {
		name: 'app',
		components: {
			tail
		},
		mounted() {
			process.on('unhandledRejection', error => {
				console.error('unhandledRejection', error);
				process.exit(1) // To exit with a 'failure' code
			});
		}
	}
</script>

<style>
	.el-pagination {
		float: right;
		font-weight: 500 !important;
		margin: 60px auto 0;
	}

	.el-pager .active {
		background-color: #00BCD4 !important;
	}

	.flex {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.FadeInTwo {
		animation: fadeInUpTwo 1000ms both;
	}
	.FadeNone{
		opacity: 0;
	}
	.FadeIn {
		animation: fadeInUp 1000ms both;
	}

	.slideIn {
		animation: slideInRight 1000ms both;
	}

	@keyframes floatY {

		0%,
		100% {
			transform: translateY(0);
		}

		50% {
			transform: translateY(-5px);
		}
	}

	@keyframes slideInRight {
		from {
			opacity: 0;
			transform: translate3d(30%, 0, 0);
			visibility: visible;
		}

		to {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}
	}

	@keyframes fadeInUpTwo {
		from {
			opacity: 0;
			transform: translate3d(0, 10%, 0);
		}

		to {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}
	}

	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translate3d(0, 100%, 0);
		}

		to {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}
	}

	@keyframes jump {

		from,
		10% {
			transform: translateY(0) scale3d(1, 1, 1);
		}

		30% {
			transform: translateY(10%) scale3d(1.05, .8, 1);
		}

		50% {
			transform: translateY(-50%) scale3d(1, 1.1, 1);
		}

		65% {
			transform: translateY(0) scale3d(1, 1, 1);
		}

		75% {
			transform: translateY(8%) scale3d(1.08, .84, 1);
		}

		85% {
			transform: translateY(6%) scale3d(1.05, .88, 1);
		}

		90%,
		to {
			transform: none;
		}
	}
	.el-select .el-input.is-focus .el-input__inner {
		border-color: #00BCD4!important;
	}

	.el-select-dropdown .selected {
		color: #00BCD4!important;
	}

	body,
	ol,
	ul,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	th,
	td,
	dl,
	dd,
	form,
	fieldset,
	legend,
	input,
	textarea,
	select {
		margin: 0;
		padding: 0
	}

	body {
		background: #fff;
		-webkit-text-size-adjust: 100%;
	}

	a {
		color: #2d374b;
		text-decoration: none
	}

	a:hover {
		color: #00BCD4;
		text-decoration: underline
	}

	em {
		font-style: normal
	}

	li {
		list-style: none
	}

	img {
		border: 0;
		vertical-align: middle
	}

	table {
		border-collapse: collapse;
		border-spacing: 0
	}

	p {
		word-wrap: break-word
	}
</style>
